import { actionCreatorFactory } from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import { RootState } from "../../state";
import {
  MegaphoneLocation,
  requestToLoadMegaphones,
  LoadMegaphonesResponse,
  requestToOpenMegaphone,
  requestToCloseMegaphone,
  requestToClickMegaphone,
  MegaphoneApiData,
} from "../api/megaphones";
import { isFailure } from "./VisitApi";

export type Megaphone = MegaphoneApiData & {
  isOpened: boolean;
  isClosed: boolean;
  isClicked: boolean;
};

export const actionCreator = actionCreatorFactory("MEGAPHONES");

export const loadMegaphones = actionCreator.async<RootState, MegaphoneLocation[], LoadMegaphonesResponse, Error>(
  "LOADED"
);

export const loadMegaphonesWorker = bindThunkAction(loadMegaphones, async (params, dispatch) => {
  const res = await dispatch(requestToLoadMegaphones(params));
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return res.payload.body;
});

export const openMegaphone = actionCreator.async<
  RootState,
  {
    location: MegaphoneLocation;
    megaphone: Megaphone;
  },
  MegaphoneLocation,
  Error
>("OPENED");

export const openMegaphoneWorker = bindThunkAction(openMegaphone, async (params, dispatch) => {
  const res = await dispatch(requestToOpenMegaphone({ analysisId: params.megaphone.analysis_id }));
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return params.location;
});

export const closeMegaphone = actionCreator.async<
  RootState,
  {
    location: MegaphoneLocation;
    megaphone: Megaphone;
  },
  MegaphoneLocation,
  Error
>("CLOSED");

export const closeMegaphoneWorker = bindThunkAction(closeMegaphone, async (params, dispatch) => {
  const res = await dispatch(requestToCloseMegaphone({ analysisId: params.megaphone.analysis_id }));
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return params.location;
});

export const clickMegaphone = actionCreator.async<
  RootState,
  {
    location: MegaphoneLocation;
    megaphone: Megaphone;
  },
  MegaphoneLocation,
  Error
>("CLICKED");

export const clickMegaphoneWorker = bindThunkAction(clickMegaphone, async (params, dispatch) => {
  const res = await dispatch(requestToClickMegaphone({ analysisId: params.megaphone.analysis_id }));
  if (isFailure(res)) {
    throw res.payload.body;
  }
  if (params.megaphone.data.url) {
    window.location.href = params.megaphone.data.url;
  }
  return params.location;
});



// WEBPACK FOOTER //
// ./frontend/src/common/actions/Megaphones.ts